import { ListingLevel } from '@deltek/specification-client/core/Models/product'
import { processEnv } from 'components/configuration/environmentVariables'
import { ListingStatus } from './ListingHeaderVariants/ListingStatusVariant'

export interface ListingRoles {
    listingType: ListingLevel
    isactive: boolean
    status: ListingStatus
    tags: { role: UserRole; views: number[] }[]
}
export interface RoleBasedAcessMatrix {
    mFGOnly: boolean
    mFG: boolean
    premium: boolean
    productListing: boolean
    submit: boolean
    update: boolean
    add: boolean
    mFGCardOnly: boolean
    premiumCard: boolean
    productListingCard: boolean
    updateSwatchbox: boolean
}
export enum UserRole {
    BPMAdmin = 'BPMAdmin',
    BPMAuthor = 'BPMAuthor',
    BPMReviewer = 'BPMReviewer',
    BPMReseller = 'BPMReseller',
    DeltekAdmin = 'DeltekAdmin',
    DeltekPublishingAuthor = 'DeltekPublishingAuthor',
    DeltekAuthor = 'DeltekAuthor',
    DeltekReviewer = 'DeltekReviewer',
    Others = 'Others',
    Onboarder = 'Onboarder',
}

export interface UserAndProductInfo extends Partial<ListingRoles> {
    userRole: UserRole
}

/*Mapping created for the privileges 

 Defines access levels to certain users */

export enum ViewMap {
    MFGOnly,
    MFG,
    Premium,
    ProductListing,
    Submit,
    Update,
    Add,
    MFGCardOnly,
    PremiumCard,
    ProductListingCard,
    UpdateLimited,
    AddProductLimited,
    UpdateSwatchbox,
}
// Listing type=Manufacturer, State=Active, Submission status=completed
//views contains  value from ViewMap enum depending on user's role,

export const MFGActiveCompleted = [
    {
        role: UserRole.BPMAdmin,
        views: [ViewMap.MFGOnly, ViewMap.MFGCardOnly], // this is equivalent to  [ViewMap.MFGOnly,ViewMap.MFGCardOnly]
    },
    {
        role: UserRole.BPMAuthor,
        views: [ViewMap.MFGOnly, ViewMap.MFGCardOnly],
    },
    {
        role: UserRole.BPMReviewer,
        views: [ViewMap.MFGOnly, ViewMap.MFGCardOnly],
    },
    {
        role: UserRole.DeltekAdmin,
        views: [ViewMap.MFGOnly, ViewMap.Update, ViewMap.MFGCardOnly],
    },
    {
        role: UserRole.DeltekPublishingAuthor,
        views: [ViewMap.MFGOnly, ViewMap.Update, ViewMap.MFGCardOnly],
    },
    {
        role: UserRole.DeltekAuthor,
        views: [ViewMap.MFGOnly, ViewMap.MFGCardOnly],
    },
    {
        role: UserRole.DeltekReviewer,
        views: [ViewMap.MFGOnly, ViewMap.MFGCardOnly],
    },
    {
        role: UserRole.Others,
        views: [ViewMap.MFGOnly, ViewMap.MFGCardOnly],
    },
    {
        role: UserRole.Onboarder,
        views: [
            ViewMap.MFGOnly,
            ViewMap.AddProductLimited,
            ViewMap.MFGCardOnly,
        ],
    },
]

export const MFGActivePremiumReview = [
    {
        role: UserRole.BPMAdmin,
        views: [
            ViewMap.MFG,
            ViewMap.Submit,
            ViewMap.Update,
            ViewMap.MFGCardOnly,
        ],
    },
    {
        role: UserRole.BPMAuthor,
        views: [
            ViewMap.MFG,
            ViewMap.Submit,
            ViewMap.Update,
            ViewMap.MFGCardOnly,
        ],
    },
    {
        role: UserRole.BPMReviewer,
        views: [ViewMap.MFG, ViewMap.MFGCardOnly],
    },
    {
        role: UserRole.DeltekAdmin,
        views: [ViewMap.MFG, ViewMap.Update, ViewMap.Add, ViewMap.MFGCardOnly],
    },
    {
        role: UserRole.DeltekPublishingAuthor,
        views: [ViewMap.MFG, ViewMap.Update, ViewMap.MFGCardOnly],
    },
    {
        role: UserRole.DeltekAuthor,
        views: [ViewMap.MFG, ViewMap.Update, ViewMap.MFGCardOnly],
    },
    {
        role: UserRole.DeltekReviewer,
        views: [ViewMap.MFG, ViewMap.MFGCardOnly],
    },
    {
        role: UserRole.Others,
        views: [ViewMap.MFGOnly, ViewMap.MFGCardOnly],
    },
    {
        role: UserRole.Onboarder,
        views: [
            ViewMap.MFG,
            ViewMap.UpdateLimited,
            ViewMap.AddProductLimited,
            ViewMap.MFGCardOnly,
        ],
    },
    { role: UserRole.BPMReseller, views: [ViewMap.UpdateSwatchbox] },
]

export const MFGActivePremiumReviewBPMSubmitted = [
    {
        role: UserRole.BPMAdmin,
        views: [ViewMap.MFG, ViewMap.Update, ViewMap.MFGCardOnly],
    },
    {
        role: UserRole.BPMAuthor,
        views: [ViewMap.MFG, ViewMap.Update, ViewMap.MFGCardOnly],
    },
    {
        role: UserRole.BPMReviewer,
        views: [ViewMap.MFG, ViewMap.MFGCardOnly],
    },
    {
        role: UserRole.DeltekAdmin,
        views: [ViewMap.MFG, ViewMap.Update, ViewMap.Add, ViewMap.MFGCardOnly],
    },
    {
        role: UserRole.DeltekPublishingAuthor,
        views: [ViewMap.MFG, ViewMap.Update, ViewMap.MFGCardOnly],
    },
    {
        role: UserRole.DeltekAuthor,
        views: [ViewMap.MFG, ViewMap.Update, ViewMap.MFGCardOnly],
    },
    {
        role: UserRole.DeltekReviewer,
        views: [ViewMap.MFG, ViewMap.MFGCardOnly],
    },
    {
        role: UserRole.Others,
        views: [ViewMap.MFGOnly, ViewMap.MFGCardOnly],
    },
    {
        role: UserRole.Onboarder,
        views: [
            ViewMap.MFG,
            ViewMap.UpdateLimited,
            ViewMap.AddProductLimited,
            ViewMap.MFGCardOnly,
        ],
    },
    { role: UserRole.BPMReseller, views: [ViewMap.UpdateSwatchbox] },
]

export const MFGActivePremiumMasterSpecReview = [
    {
        role: UserRole.BPMAdmin,
        views: [
            ViewMap.MFG,
            ViewMap.Submit,
            ViewMap.Update,
            ViewMap.MFGCardOnly,
        ],
    },
    {
        role: UserRole.BPMAuthor,
        views: [
            ViewMap.MFG,
            ViewMap.Submit,
            ViewMap.Update,
            ViewMap.MFGCardOnly,
        ],
    },
    {
        role: UserRole.BPMReviewer,
        views: [ViewMap.MFG, ViewMap.MFGCardOnly],
    },
    {
        role: UserRole.DeltekAdmin,
        views: [ViewMap.MFG, ViewMap.Update, ViewMap.Add, ViewMap.MFGCardOnly],
    },
    {
        role: UserRole.DeltekPublishingAuthor,
        views: [ViewMap.MFG, ViewMap.Update, ViewMap.MFGCardOnly],
    },
    {
        role: UserRole.DeltekAuthor,
        views: [ViewMap.MFG, ViewMap.Update, ViewMap.MFGCardOnly],
    },
    {
        role: UserRole.DeltekReviewer,
        views: [ViewMap.MFG, ViewMap.MFGCardOnly],
    },
    {
        role: UserRole.Others,
        views: [ViewMap.MFGOnly, ViewMap.MFGCardOnly],
    },
    {
        role: UserRole.Onboarder,
        views: [
            ViewMap.MFG,
            ViewMap.UpdateLimited,
            ViewMap.AddProductLimited,
            ViewMap.MFGCardOnly,
        ],
    },
    { role: UserRole.BPMReseller, views: [ViewMap.UpdateSwatchbox] },
]

export const MFGActivePremiumMasterSpecReviewBPMSubmitted = [
    {
        role: UserRole.BPMAdmin,
        views: [ViewMap.MFG, ViewMap.Update, ViewMap.MFGCardOnly],
    },
    {
        role: UserRole.BPMAuthor,
        views: [ViewMap.MFG, ViewMap.Update, ViewMap.MFGCardOnly],
    },
    {
        role: UserRole.BPMReviewer,
        views: [ViewMap.MFG, ViewMap.MFGCardOnly],
    },
    {
        role: UserRole.DeltekAdmin,
        views: [ViewMap.MFG, ViewMap.Update, ViewMap.Add, ViewMap.MFGCardOnly],
    },
    {
        role: UserRole.DeltekPublishingAuthor,
        views: [ViewMap.MFG, ViewMap.Update, ViewMap.MFGCardOnly],
    },
    {
        role: UserRole.DeltekAuthor,
        views: [ViewMap.MFG, ViewMap.Update, ViewMap.MFGCardOnly],
    },
    {
        role: UserRole.DeltekReviewer,
        views: [ViewMap.MFG, ViewMap.MFGCardOnly],
    },
    {
        role: UserRole.Others,
        views: [ViewMap.MFGOnly, ViewMap.MFGCardOnly],
    },
    {
        role: UserRole.Onboarder,
        views: [
            ViewMap.MFG,
            ViewMap.UpdateLimited,
            ViewMap.AddProductLimited,
            ViewMap.MFGCardOnly,
        ],
    },
    { role: UserRole.BPMReseller, views: [ViewMap.UpdateSwatchbox] },
]

export const MFGActivePremiumProprietaryReview = [
    {
        role: UserRole.BPMAdmin,
        views: [
            ViewMap.MFG,
            ViewMap.Submit,
            ViewMap.Update,
            ViewMap.MFGCardOnly,
        ],
    },
    {
        role: UserRole.BPMAuthor,
        views: [
            ViewMap.MFG,
            ViewMap.Submit,
            ViewMap.Update,
            ViewMap.MFGCardOnly,
        ],
    },
    {
        role: UserRole.BPMReviewer,
        views: [ViewMap.MFG, ViewMap.MFGCardOnly],
    },
    {
        role: UserRole.DeltekAdmin,
        views: [ViewMap.MFG, ViewMap.Update, ViewMap.Add, ViewMap.MFGCardOnly],
    },
    {
        role: UserRole.DeltekPublishingAuthor,
        views: [ViewMap.MFG, ViewMap.Update, ViewMap.MFGCardOnly],
    },
    {
        role: UserRole.DeltekAuthor,
        views: [ViewMap.MFG, ViewMap.Update, ViewMap.MFGCardOnly],
    },
    {
        role: UserRole.DeltekReviewer,
        views: [ViewMap.MFG, ViewMap.MFGCardOnly],
    },
    {
        role: UserRole.Others,
        views: [ViewMap.MFGOnly, ViewMap.MFGCardOnly],
    },
    {
        role: UserRole.Onboarder,
        views: [
            ViewMap.MFG,
            ViewMap.UpdateLimited,
            ViewMap.AddProductLimited,
            ViewMap.MFGCardOnly,
        ],
    },
    { role: UserRole.BPMReseller, views: [ViewMap.UpdateSwatchbox] },
]

export const MFGActivePremiumProprietaryReviewBPMSubmitted = [
    {
        role: UserRole.BPMAdmin,
        views: [ViewMap.MFG, ViewMap.Update, ViewMap.MFGCardOnly],
    },
    {
        role: UserRole.BPMAuthor,
        views: [ViewMap.MFG, ViewMap.Update, ViewMap.MFGCardOnly],
    },
    {
        role: UserRole.BPMReviewer,
        views: [ViewMap.MFG, ViewMap.MFGCardOnly],
    },
    {
        role: UserRole.DeltekAdmin,
        views: [ViewMap.MFG, ViewMap.Update, ViewMap.Add, ViewMap.MFGCardOnly],
    },
    {
        role: UserRole.DeltekPublishingAuthor,
        views: [ViewMap.MFG, ViewMap.Update, ViewMap.MFGCardOnly],
    },
    {
        role: UserRole.DeltekAuthor,
        views: [ViewMap.MFG, ViewMap.Update, ViewMap.MFGCardOnly],
    },
    {
        role: UserRole.DeltekReviewer,
        views: [ViewMap.MFG, ViewMap.MFGCardOnly],
    },
    {
        role: UserRole.Others,
        views: [ViewMap.MFGOnly, ViewMap.MFGCardOnly],
    },
    {
        role: UserRole.Onboarder,
        views: [
            ViewMap.MFG,
            ViewMap.UpdateLimited,
            ViewMap.AddProductLimited,
            ViewMap.MFGCardOnly,
        ],
    },
    { role: UserRole.BPMReseller, views: [ViewMap.UpdateSwatchbox] },
]

export const MFGActiveInReview = [
    {
        role: UserRole.BPMAdmin,
        views: [
            ViewMap.MFG,
            ViewMap.Submit,
            ViewMap.Update,
            ViewMap.MFGCardOnly,
        ],
    },
    {
        role: UserRole.BPMAuthor,
        views: [
            ViewMap.MFG,
            ViewMap.Submit,
            ViewMap.Update,
            ViewMap.MFGCardOnly,
        ],
    },
    {
        role: UserRole.BPMReviewer,
        views: [ViewMap.MFG, ViewMap.MFGCardOnly],
    },
    {
        role: UserRole.DeltekAdmin,
        views: [ViewMap.MFG, ViewMap.Update, ViewMap.Add, ViewMap.MFGCardOnly],
    },
    {
        role: UserRole.DeltekPublishingAuthor,
        views: [ViewMap.MFG, ViewMap.Update, ViewMap.MFGCardOnly],
    },
    {
        role: UserRole.DeltekAuthor,
        views: [ViewMap.MFG, ViewMap.Update, ViewMap.MFGCardOnly],
    },
    {
        role: UserRole.DeltekReviewer,
        views: [ViewMap.MFG, ViewMap.MFGCardOnly],
    },
    {
        role: UserRole.Others,
        views: [ViewMap.MFGOnly, ViewMap.MFGCardOnly],
    },
    {
        role: UserRole.Onboarder,
        views: [
            ViewMap.MFG,
            ViewMap.UpdateLimited,
            ViewMap.AddProductLimited,
            ViewMap.MFGCardOnly,
        ],
    },
    { role: UserRole.BPMReseller, views: [ViewMap.UpdateSwatchbox] },
]

export const MFGActiveBPMSubmitted = [
    {
        role: UserRole.BPMAdmin,
        views: [ViewMap.MFG, ViewMap.Update, ViewMap.MFGCardOnly],
    },
    {
        role: UserRole.BPMAuthor,
        views: [ViewMap.MFG, ViewMap.Update, ViewMap.MFGCardOnly],
    },
    {
        role: UserRole.BPMReviewer,
        views: [ViewMap.MFG, ViewMap.MFGCardOnly],
    },
    {
        role: UserRole.DeltekAdmin,
        views: [ViewMap.MFG, ViewMap.Update, ViewMap.Add, ViewMap.MFGCardOnly],
    },
    {
        role: UserRole.DeltekPublishingAuthor,
        views: [ViewMap.MFG, ViewMap.Update, ViewMap.MFGCardOnly],
    },
    {
        role: UserRole.DeltekAuthor,
        views: [ViewMap.MFG, ViewMap.Update, ViewMap.MFGCardOnly],
    },
    {
        role: UserRole.DeltekReviewer,
        views: [ViewMap.MFG, ViewMap.MFGCardOnly],
    },
    {
        role: UserRole.Others,
        views: [ViewMap.MFGOnly, ViewMap.MFGCardOnly],
    },
    {
        role: UserRole.Onboarder,
        views: [
            ViewMap.MFG,
            ViewMap.UpdateLimited,
            ViewMap.AddProductLimited,
            ViewMap.MFGCardOnly,
        ],
    },
    { role: UserRole.BPMReseller, views: [ViewMap.UpdateSwatchbox] },
]

export const MFGInactiveCompleted = [
    {
        role: UserRole.BPMAdmin,
        views: [ViewMap.MFG, ViewMap.MFGCardOnly],
    },
    {
        role: UserRole.BPMAuthor,
        views: [ViewMap.MFG, ViewMap.MFGCardOnly],
    },
    {
        role: UserRole.BPMReviewer,
        views: [ViewMap.MFG, ViewMap.MFGCardOnly],
    },
    {
        role: UserRole.DeltekAdmin,
        views: [ViewMap.MFG, ViewMap.Update, ViewMap.Add, ViewMap.MFGCardOnly],
    },
    {
        role: UserRole.DeltekPublishingAuthor,
        views: [ViewMap.MFG, ViewMap.Update, ViewMap.MFGCardOnly],
    },
    {
        role: UserRole.DeltekAuthor,
        views: [ViewMap.MFG, ViewMap.Update, ViewMap.MFGCardOnly],
    },
    {
        role: UserRole.DeltekReviewer,
        views: [ViewMap.MFG, ViewMap.MFGCardOnly],
    },
    {
        role: UserRole.Others,
        views: [ViewMap.MFGOnly, ViewMap.MFGCardOnly],
    },
    {
        role: UserRole.Onboarder,
        views: [
            ViewMap.MFG,
            ViewMap.UpdateLimited,
            ViewMap.AddProductLimited,
            ViewMap.MFGCardOnly,
        ],
    },
]

export const MFGInactivePremiumReview = [
    {
        role: UserRole.BPMAdmin,
        views: [ViewMap.MFG, ViewMap.MFGCardOnly],
    },
    {
        role: UserRole.BPMAuthor,
        views: [ViewMap.MFG, ViewMap.MFGCardOnly],
    },
    {
        role: UserRole.BPMReviewer,
        views: [ViewMap.MFG, ViewMap.MFGCardOnly],
    },
    {
        role: UserRole.DeltekAdmin,
        views: [ViewMap.MFG, ViewMap.Update, ViewMap.Add, ViewMap.MFGCardOnly],
    },
    {
        role: UserRole.DeltekPublishingAuthor,
        views: [ViewMap.MFG, ViewMap.Update, ViewMap.MFGCardOnly],
    },
    {
        role: UserRole.DeltekAuthor,
        views: [ViewMap.MFG, ViewMap.Update, ViewMap.MFGCardOnly],
    },
    {
        role: UserRole.DeltekReviewer,
        views: [ViewMap.MFG, ViewMap.MFGCardOnly],
    },
    {
        role: UserRole.Others,
        views: [ViewMap.MFGOnly, ViewMap.MFGCardOnly],
    },
    {
        role: UserRole.Onboarder,
        views: [
            ViewMap.MFG,
            ViewMap.UpdateLimited,
            ViewMap.AddProductLimited,
            ViewMap.MFGCardOnly,
        ],
    },
]

export const MFGInactivePremiumReviewBPMSubmitted = [
    {
        role: UserRole.BPMAdmin,
        views: [ViewMap.MFG, ViewMap.MFGCardOnly],
    },
    {
        role: UserRole.BPMAuthor,
        views: [ViewMap.MFG, ViewMap.MFGCardOnly],
    },
    {
        role: UserRole.BPMReviewer,
        views: [ViewMap.MFG, ViewMap.MFGCardOnly],
    },
    {
        role: UserRole.DeltekAdmin,
        views: [ViewMap.MFG, ViewMap.Update, ViewMap.Add, ViewMap.MFGCardOnly],
    },
    {
        role: UserRole.DeltekPublishingAuthor,
        views: [ViewMap.MFG, ViewMap.Update, ViewMap.MFGCardOnly],
    },
    {
        role: UserRole.DeltekAuthor,
        views: [ViewMap.MFG, ViewMap.Update, ViewMap.MFGCardOnly],
    },
    {
        role: UserRole.DeltekReviewer,
        views: [ViewMap.MFG, ViewMap.MFGCardOnly],
    },
    {
        role: UserRole.Others,
        views: [ViewMap.MFGOnly, ViewMap.MFGCardOnly],
    },
    {
        role: UserRole.Onboarder,
        views: [
            ViewMap.MFG,
            ViewMap.UpdateLimited,
            ViewMap.AddProductLimited,
            ViewMap.MFGCardOnly,
        ],
    },
]

export const MFGInactivePremiumMasterSpecReview = [
    {
        role: UserRole.BPMAdmin,
        views: [ViewMap.MFG, ViewMap.MFGCardOnly],
    },
    {
        role: UserRole.BPMAuthor,
        views: [ViewMap.MFG, ViewMap.MFGCardOnly],
    },
    {
        role: UserRole.BPMReviewer,
        views: [ViewMap.MFG, ViewMap.MFGCardOnly],
    },
    {
        role: UserRole.DeltekAdmin,
        views: [ViewMap.MFG, ViewMap.Update, ViewMap.Add, ViewMap.MFGCardOnly],
    },
    {
        role: UserRole.DeltekPublishingAuthor,
        views: [ViewMap.MFG, ViewMap.Update, ViewMap.MFGCardOnly],
    },
    {
        role: UserRole.DeltekAuthor,
        views: [ViewMap.MFG, ViewMap.Update, ViewMap.MFGCardOnly],
    },
    {
        role: UserRole.DeltekReviewer,
        views: [ViewMap.MFG, ViewMap.MFGCardOnly],
    },
    {
        role: UserRole.Others,
        views: [ViewMap.MFGOnly, ViewMap.MFGCardOnly],
    },
    {
        role: UserRole.Onboarder,
        views: [
            ViewMap.MFG,
            ViewMap.UpdateLimited,
            ViewMap.AddProductLimited,
            ViewMap.MFGCardOnly,
        ],
    },
]

export const MFGInactivePremiumMasterSpecReviewBPMSubmitted = [
    {
        role: UserRole.BPMAdmin,
        views: [ViewMap.MFG, ViewMap.MFGCardOnly],
    },
    {
        role: UserRole.BPMAuthor,
        views: [ViewMap.MFG, ViewMap.MFGCardOnly],
    },
    {
        role: UserRole.BPMReviewer,
        views: [ViewMap.MFG, ViewMap.MFGCardOnly],
    },
    {
        role: UserRole.DeltekAdmin,
        views: [ViewMap.MFG, ViewMap.Update, ViewMap.Add, ViewMap.MFGCardOnly],
    },
    {
        role: UserRole.DeltekPublishingAuthor,
        views: [ViewMap.MFG, ViewMap.Update, ViewMap.MFGCardOnly],
    },
    {
        role: UserRole.DeltekAuthor,
        views: [ViewMap.MFG, ViewMap.Update, ViewMap.MFGCardOnly],
    },
    {
        role: UserRole.DeltekReviewer,
        views: [ViewMap.MFG, ViewMap.MFGCardOnly],
    },
    {
        role: UserRole.Others,
        views: [ViewMap.MFGOnly, ViewMap.MFGCardOnly],
    },
    {
        role: UserRole.Onboarder,
        views: [
            ViewMap.MFG,
            ViewMap.UpdateLimited,
            ViewMap.AddProductLimited,
            ViewMap.MFGCardOnly,
        ],
    },
]

export const MFGInactivePremiumProprietaryReview = [
    {
        role: UserRole.BPMAdmin,
        views: [ViewMap.MFG, ViewMap.MFGCardOnly],
    },
    {
        role: UserRole.BPMAuthor,
        views: [ViewMap.MFG, ViewMap.MFGCardOnly],
    },
    {
        role: UserRole.BPMReviewer,
        views: [ViewMap.MFG, ViewMap.MFGCardOnly],
    },
    {
        role: UserRole.DeltekAdmin,
        views: [ViewMap.MFG, ViewMap.Update, ViewMap.Add, ViewMap.MFGCardOnly],
    },
    {
        role: UserRole.DeltekPublishingAuthor,
        views: [ViewMap.MFG, ViewMap.Update, ViewMap.MFGCardOnly],
    },
    {
        role: UserRole.DeltekAuthor,
        views: [ViewMap.MFG, ViewMap.Update, ViewMap.MFGCardOnly],
    },
    {
        role: UserRole.DeltekReviewer,
        views: [ViewMap.MFG, ViewMap.MFGCardOnly],
    },
    {
        role: UserRole.Others,
        views: [ViewMap.MFGOnly, ViewMap.MFGCardOnly],
    },
    {
        role: UserRole.Onboarder,
        views: [
            ViewMap.MFG,
            ViewMap.UpdateLimited,
            ViewMap.AddProductLimited,
            ViewMap.MFGCardOnly,
        ],
    },
]

export const MFGInactivePremiumProprietaryReviewBPMSubmitted = [
    {
        role: UserRole.BPMAdmin,
        views: [ViewMap.MFG, ViewMap.MFGCardOnly],
    },
    {
        role: UserRole.BPMAuthor,
        views: [ViewMap.MFG, ViewMap.MFGCardOnly],
    },
    {
        role: UserRole.BPMReviewer,
        views: [ViewMap.MFG, ViewMap.MFGCardOnly],
    },
    {
        role: UserRole.DeltekAdmin,
        views: [ViewMap.MFG, ViewMap.Update, ViewMap.Add, ViewMap.MFGCardOnly],
    },
    {
        role: UserRole.DeltekPublishingAuthor,
        views: [ViewMap.MFG, ViewMap.Update, ViewMap.MFGCardOnly],
    },
    {
        role: UserRole.DeltekAuthor,
        views: [ViewMap.MFG, ViewMap.Update, ViewMap.MFGCardOnly],
    },
    {
        role: UserRole.DeltekReviewer,
        views: [ViewMap.MFG, ViewMap.MFGCardOnly],
    },
    {
        role: UserRole.Others,
        views: [ViewMap.MFGOnly, ViewMap.MFGCardOnly],
    },
    {
        role: UserRole.Onboarder,
        views: [
            ViewMap.MFG,
            ViewMap.UpdateLimited,
            ViewMap.AddProductLimited,
            ViewMap.MFGCardOnly,
        ],
    },
]

export const MFGInactiveInReview = [
    {
        role: UserRole.BPMAdmin,
        views: [ViewMap.MFG, ViewMap.MFGCardOnly],
    },
    {
        role: UserRole.BPMAuthor,
        views: [ViewMap.MFG, ViewMap.MFGCardOnly],
    },
    {
        role: UserRole.BPMReviewer,
        views: [ViewMap.MFG, ViewMap.MFGCardOnly],
    },
    {
        role: UserRole.DeltekAdmin,
        views: [ViewMap.MFG, ViewMap.Update, ViewMap.Add, ViewMap.MFGCardOnly],
    },
    {
        role: UserRole.DeltekPublishingAuthor,
        views: [ViewMap.MFG, ViewMap.Update, ViewMap.MFGCardOnly],
    },
    {
        role: UserRole.DeltekAuthor,
        views: [ViewMap.MFG, ViewMap.Update, ViewMap.MFGCardOnly],
    },
    {
        role: UserRole.DeltekReviewer,
        views: [ViewMap.MFG, ViewMap.MFGCardOnly],
    },
    {
        role: UserRole.Others,
        views: [ViewMap.MFGOnly, ViewMap.MFGCardOnly],
    },
    {
        role: UserRole.Onboarder,
        views: [
            ViewMap.MFG,
            ViewMap.UpdateLimited,
            ViewMap.AddProductLimited,
            ViewMap.MFGCardOnly,
        ],
    },
]

export const MFGInactiveBPMSubmitted = [
    {
        role: UserRole.BPMAdmin,
        views: [ViewMap.MFG, ViewMap.MFGCardOnly],
    },
    {
        role: UserRole.BPMAuthor,
        views: [ViewMap.MFG, ViewMap.MFGCardOnly],
    },
    {
        role: UserRole.BPMReviewer,
        views: [ViewMap.MFG, ViewMap.MFGCardOnly],
    },
    {
        role: UserRole.DeltekAdmin,
        views: [ViewMap.MFG, ViewMap.Update, ViewMap.Add, ViewMap.MFGCardOnly],
    },
    {
        role: UserRole.DeltekPublishingAuthor,
        views: [ViewMap.MFG, ViewMap.Update, ViewMap.MFGCardOnly],
    },
    {
        role: UserRole.DeltekAuthor,
        views: [ViewMap.MFG, ViewMap.Update, ViewMap.MFGCardOnly],
    },
    {
        role: UserRole.DeltekReviewer,
        views: [ViewMap.MFG, ViewMap.MFGCardOnly],
    },
    {
        role: UserRole.Others,
        views: [ViewMap.MFGOnly, ViewMap.MFGCardOnly],
    },
    {
        role: UserRole.Onboarder,
        views: [
            ViewMap.MFG,
            ViewMap.UpdateLimited,
            ViewMap.AddProductLimited,
            ViewMap.MFGCardOnly,
        ],
    },
]

export const PremiumActiveComplete = [
    {
        role: UserRole.BPMAdmin,
        views: [ViewMap.Premium, ViewMap.PremiumCard],
    },
    {
        role: UserRole.BPMAuthor,
        views: [ViewMap.Premium, ViewMap.PremiumCard],
    },
    {
        role: UserRole.BPMReviewer,
        views: [ViewMap.Premium, ViewMap.PremiumCard],
    },
    {
        role: UserRole.DeltekAdmin,
        views: [
            ViewMap.Premium,
            ViewMap.Update,
            ViewMap.Add,
            ViewMap.PremiumCard,
        ],
    },
    {
        role: UserRole.DeltekPublishingAuthor,
        views: [ViewMap.Premium, ViewMap.Update, ViewMap.PremiumCard],
    },
    {
        role: UserRole.DeltekAuthor,
        views: [ViewMap.Premium, ViewMap.Update, ViewMap.PremiumCard],
    },
    {
        role: UserRole.DeltekReviewer,
        views: [ViewMap.Premium, ViewMap.PremiumCard],
    },
    {
        role: UserRole.Others,
        views: [ViewMap.Premium, ViewMap.PremiumCard],
    },
    {
        role: UserRole.Onboarder,
        views: [
            ViewMap.Premium,
            ViewMap.UpdateLimited,
            ViewMap.AddProductLimited,
            ViewMap.PremiumCard,
        ],
    },
]

export const PremiumActivePremiumReview = [
    {
        role: UserRole.BPMAdmin,
        views: [
            ViewMap.Premium,
            ViewMap.Submit,
            ViewMap.Update,
            ViewMap.PremiumCard,
        ],
    },
    {
        role: UserRole.BPMAuthor,
        views: [
            ViewMap.Premium,
            ViewMap.Submit,
            ViewMap.Update,
            ViewMap.PremiumCard,
        ],
    },
    {
        role: UserRole.BPMReviewer,
        views: [ViewMap.Premium, ViewMap.PremiumCard],
    },
    {
        role: UserRole.DeltekAdmin,
        views: [
            ViewMap.Premium,
            ViewMap.Update,
            ViewMap.Add,
            ViewMap.PremiumCard,
        ],
    },
    {
        role: UserRole.DeltekPublishingAuthor,
        views: [ViewMap.Premium, ViewMap.Update, ViewMap.PremiumCard],
    },
    {
        role: UserRole.DeltekAuthor,
        views: [ViewMap.Premium, ViewMap.Update, ViewMap.PremiumCard],
    },
    {
        role: UserRole.DeltekReviewer,
        views: [ViewMap.Premium, ViewMap.PremiumCard],
    },
    {
        role: UserRole.Others,
        views: [ViewMap.Premium, ViewMap.PremiumCard],
    },
    {
        role: UserRole.Onboarder,
        views: [
            ViewMap.Premium,
            ViewMap.UpdateLimited,
            ViewMap.AddProductLimited,
            ViewMap.PremiumCard,
        ],
    },
    { role: UserRole.BPMReseller, views: [ViewMap.UpdateSwatchbox] },
]

export const PremiumActivePremiumReviewBPMSubmitted = [
    {
        role: UserRole.BPMAdmin,
        views: [ViewMap.Premium, ViewMap.Update, ViewMap.PremiumCard],
    },
    {
        role: UserRole.BPMAuthor,
        views: [ViewMap.Premium, ViewMap.Update, ViewMap.PremiumCard],
    },
    {
        role: UserRole.BPMReviewer,
        views: [ViewMap.Premium, ViewMap.PremiumCard],
    },
    {
        role: UserRole.DeltekAdmin,
        views: [
            ViewMap.Premium,
            ViewMap.Update,
            ViewMap.Add,
            ViewMap.PremiumCard,
        ],
    },
    {
        role: UserRole.DeltekPublishingAuthor,
        views: [ViewMap.Premium, ViewMap.Update, ViewMap.PremiumCard],
    },
    {
        role: UserRole.DeltekAuthor,
        views: [ViewMap.Premium, ViewMap.Update, ViewMap.PremiumCard],
    },
    {
        role: UserRole.DeltekReviewer,
        views: [ViewMap.Premium, ViewMap.PremiumCard],
    },
    {
        role: UserRole.Others,
        views: [ViewMap.Premium, ViewMap.PremiumCard],
    },
    {
        role: UserRole.Onboarder,
        views: [
            ViewMap.Premium,
            ViewMap.UpdateLimited,
            ViewMap.AddProductLimited,
            ViewMap.PremiumCard,
        ],
    },
    { role: UserRole.BPMReseller, views: [ViewMap.UpdateSwatchbox] },
]

export const PremiumActivePremiumMasterSpecReview = [
    {
        role: UserRole.BPMAdmin,
        views: [
            ViewMap.Premium,
            ViewMap.Submit,
            ViewMap.Update,
            ViewMap.PremiumCard,
        ],
    },
    {
        role: UserRole.BPMAuthor,
        views: [
            ViewMap.Premium,
            ViewMap.Submit,
            ViewMap.Update,
            ViewMap.PremiumCard,
        ],
    },
    {
        role: UserRole.BPMReviewer,
        views: [ViewMap.Premium, ViewMap.PremiumCard],
    },
    {
        role: UserRole.DeltekAdmin,
        views: [
            ViewMap.Premium,
            ViewMap.Update,
            ViewMap.Add,
            ViewMap.PremiumCard,
        ],
    },
    {
        role: UserRole.DeltekPublishingAuthor,
        views: [ViewMap.Premium, ViewMap.Update, ViewMap.PremiumCard],
    },
    {
        role: UserRole.DeltekAuthor,
        views: [ViewMap.Premium, ViewMap.Update, ViewMap.PremiumCard],
    },
    {
        role: UserRole.DeltekReviewer,
        views: [ViewMap.Premium, ViewMap.PremiumCard],
    },
    {
        role: UserRole.Others,
        views: [ViewMap.Premium, ViewMap.PremiumCard],
    },
    {
        role: UserRole.Onboarder,
        views: [
            ViewMap.Premium,
            ViewMap.UpdateLimited,
            ViewMap.AddProductLimited,
            ViewMap.PremiumCard,
        ],
    },
    { role: UserRole.BPMReseller, views: [ViewMap.UpdateSwatchbox] },
]

export const PremiumActivePremiumMasterSpecReviewBPMSubmitted = [
    {
        role: UserRole.BPMAdmin,
        views: [ViewMap.Premium, ViewMap.Update, ViewMap.PremiumCard],
    },
    {
        role: UserRole.BPMAuthor,
        views: [ViewMap.Premium, ViewMap.Update, ViewMap.PremiumCard],
    },
    {
        role: UserRole.BPMReviewer,
        views: [ViewMap.Premium, ViewMap.PremiumCard],
    },
    {
        role: UserRole.DeltekAdmin,
        views: [
            ViewMap.Premium,
            ViewMap.Update,
            ViewMap.Add,
            ViewMap.PremiumCard,
        ],
    },
    {
        role: UserRole.DeltekPublishingAuthor,
        views: [ViewMap.Premium, ViewMap.Update, ViewMap.PremiumCard],
    },
    {
        role: UserRole.DeltekAuthor,
        views: [ViewMap.Premium, ViewMap.Update, ViewMap.PremiumCard],
    },
    {
        role: UserRole.DeltekReviewer,
        views: [ViewMap.Premium, ViewMap.PremiumCard],
    },
    {
        role: UserRole.Others,
        views: [ViewMap.Premium, ViewMap.PremiumCard],
    },
    {
        role: UserRole.Onboarder,
        views: [
            ViewMap.Premium,
            ViewMap.UpdateLimited,
            ViewMap.AddProductLimited,
            ViewMap.PremiumCard,
        ],
    },
    { role: UserRole.BPMReseller, views: [ViewMap.UpdateSwatchbox] },
]

export const PremiumActivePremiumProprietaryReview = [
    {
        role: UserRole.BPMAdmin,
        views: [
            ViewMap.Premium,
            ViewMap.Submit,
            ViewMap.Update,
            ViewMap.PremiumCard,
        ],
    },
    {
        role: UserRole.BPMAuthor,
        views: [
            ViewMap.Premium,
            ViewMap.Submit,
            ViewMap.Update,
            ViewMap.PremiumCard,
        ],
    },
    {
        role: UserRole.BPMReviewer,
        views: [ViewMap.Premium, ViewMap.PremiumCard],
    },
    {
        role: UserRole.DeltekAdmin,
        views: [
            ViewMap.Premium,
            ViewMap.Update,
            ViewMap.Add,
            ViewMap.PremiumCard,
        ],
    },
    {
        role: UserRole.DeltekPublishingAuthor,
        views: [ViewMap.Premium, ViewMap.Update, ViewMap.PremiumCard],
    },
    {
        role: UserRole.DeltekAuthor,
        views: [ViewMap.Premium, ViewMap.Update, ViewMap.PremiumCard],
    },
    {
        role: UserRole.DeltekReviewer,
        views: [ViewMap.Premium, ViewMap.PremiumCard],
    },
    {
        role: UserRole.Others,
        views: [ViewMap.Premium, ViewMap.PremiumCard],
    },
    {
        role: UserRole.Onboarder,
        views: [
            ViewMap.Premium,
            ViewMap.UpdateLimited,
            ViewMap.AddProductLimited,
            ViewMap.PremiumCard,
        ],
    },
    { role: UserRole.BPMReseller, views: [ViewMap.UpdateSwatchbox] },
]

export const PremiumActivePremiumProprietaryReviewBPMSubmitted = [
    {
        role: UserRole.BPMAdmin,
        views: [ViewMap.Premium, ViewMap.Update, ViewMap.PremiumCard],
    },
    {
        role: UserRole.BPMAuthor,
        views: [ViewMap.Premium, ViewMap.Update, ViewMap.PremiumCard],
    },
    {
        role: UserRole.BPMReviewer,
        views: [ViewMap.Premium, ViewMap.PremiumCard],
    },
    {
        role: UserRole.DeltekAdmin,
        views: [
            ViewMap.Premium,
            ViewMap.Update,
            ViewMap.Add,
            ViewMap.PremiumCard,
        ],
    },
    {
        role: UserRole.DeltekPublishingAuthor,
        views: [ViewMap.Premium, ViewMap.Update, ViewMap.PremiumCard],
    },
    {
        role: UserRole.DeltekAuthor,
        views: [ViewMap.Premium, ViewMap.Update, ViewMap.PremiumCard],
    },
    {
        role: UserRole.DeltekReviewer,
        views: [ViewMap.Premium, ViewMap.PremiumCard],
    },
    {
        role: UserRole.Others,
        views: [ViewMap.Premium, ViewMap.PremiumCard],
    },
    {
        role: UserRole.Onboarder,
        views: [
            ViewMap.Premium,
            ViewMap.UpdateLimited,
            ViewMap.AddProductLimited,
            ViewMap.PremiumCard,
        ],
    },
    { role: UserRole.BPMReseller, views: [ViewMap.UpdateSwatchbox] },
]

export const PremiumInactiveComplete = [
    {
        role: UserRole.BPMAdmin,
        views: [ViewMap.Premium, ViewMap.PremiumCard],
    },
    {
        role: UserRole.BPMAuthor,
        views: [ViewMap.Premium, ViewMap.PremiumCard],
    },
    {
        role: UserRole.BPMReviewer,
        views: [ViewMap.Premium, ViewMap.PremiumCard],
    },
    {
        role: UserRole.DeltekAdmin,
        views: [
            ViewMap.Premium,
            ViewMap.Update,
            ViewMap.Add,
            ViewMap.PremiumCard,
        ],
    },
    {
        role: UserRole.DeltekPublishingAuthor,
        views: [ViewMap.Premium, ViewMap.Update, ViewMap.PremiumCard],
    },
    {
        role: UserRole.DeltekAuthor,
        views: [ViewMap.Premium, ViewMap.Update, ViewMap.PremiumCard],
    },
    {
        role: UserRole.DeltekReviewer,
        views: [ViewMap.Premium, ViewMap.PremiumCard],
    },
    {
        role: UserRole.Others,
        views: [ViewMap.Premium, ViewMap.PremiumCard],
    },
    {
        role: UserRole.Onboarder,
        views: [
            ViewMap.Premium,
            ViewMap.UpdateLimited,
            ViewMap.AddProductLimited,
            ViewMap.PremiumCard,
        ],
    },
]

export const PremiumInactivePremiumReview = [
    {
        role: UserRole.BPMAdmin,
        views: [
            ViewMap.Premium,
            ViewMap.Submit,
            ViewMap.Update,
            ViewMap.PremiumCard,
        ],
    },
    {
        role: UserRole.BPMAuthor,
        views: [
            ViewMap.Premium,
            ViewMap.Submit,
            ViewMap.Update,
            ViewMap.PremiumCard,
        ],
    },
    {
        role: UserRole.BPMReviewer,
        views: [ViewMap.Premium, ViewMap.PremiumCard],
    },
    {
        role: UserRole.DeltekAdmin,
        views: [
            ViewMap.Premium,
            ViewMap.Update,
            ViewMap.Add,
            ViewMap.PremiumCard,
        ],
    },
    {
        role: UserRole.DeltekPublishingAuthor,
        views: [ViewMap.Premium, ViewMap.Update, ViewMap.PremiumCard],
    },
    {
        role: UserRole.DeltekAuthor,
        views: [ViewMap.Premium, ViewMap.Update, ViewMap.PremiumCard],
    },
    {
        role: UserRole.DeltekReviewer,
        views: [ViewMap.Premium, ViewMap.PremiumCard],
    },
    {
        role: UserRole.Others,
        views: [ViewMap.Premium, ViewMap.PremiumCard],
    },
    {
        role: UserRole.Onboarder,
        views: [
            ViewMap.Premium,
            ViewMap.UpdateLimited,
            ViewMap.AddProductLimited,
            ViewMap.PremiumCard,
        ],
    },
    { role: UserRole.BPMReseller, views: [ViewMap.UpdateSwatchbox] },
]

export const PremiumInactivePremiumReviewBPMSubmitted = [
    {
        role: UserRole.BPMAdmin,
        views: [ViewMap.Premium, ViewMap.Update, ViewMap.PremiumCard],
    },
    {
        role: UserRole.BPMAuthor,
        views: [ViewMap.Premium, ViewMap.Update, ViewMap.PremiumCard],
    },
    {
        role: UserRole.BPMReviewer,
        views: [ViewMap.Premium, ViewMap.PremiumCard],
    },
    {
        role: UserRole.DeltekAdmin,
        views: [
            ViewMap.Premium,
            ViewMap.Update,
            ViewMap.Add,
            ViewMap.PremiumCard,
        ],
    },
    {
        role: UserRole.DeltekPublishingAuthor,
        views: [ViewMap.Premium, ViewMap.Update, ViewMap.PremiumCard],
    },
    {
        role: UserRole.DeltekAuthor,
        views: [ViewMap.Premium, ViewMap.Update, ViewMap.PremiumCard],
    },
    {
        role: UserRole.DeltekReviewer,
        views: [ViewMap.Premium, ViewMap.PremiumCard],
    },
    {
        role: UserRole.Others,
        views: [ViewMap.Premium, ViewMap.PremiumCard],
    },
    {
        role: UserRole.Onboarder,
        views: [
            ViewMap.Premium,
            ViewMap.UpdateLimited,
            ViewMap.AddProductLimited,
            ViewMap.PremiumCard,
        ],
    },
    { role: UserRole.BPMReseller, views: [ViewMap.UpdateSwatchbox] },
]

export const PremiumInactivePremiumMasterSpecReview = [
    {
        role: UserRole.BPMAdmin,
        views: [
            ViewMap.Premium,
            ViewMap.Submit,
            ViewMap.Update,
            ViewMap.PremiumCard,
        ],
    },
    {
        role: UserRole.BPMAuthor,
        views: [
            ViewMap.Premium,
            ViewMap.Submit,
            ViewMap.Update,
            ViewMap.PremiumCard,
        ],
    },
    {
        role: UserRole.BPMReviewer,
        views: [ViewMap.Premium, ViewMap.PremiumCard],
    },
    {
        role: UserRole.DeltekAdmin,
        views: [
            ViewMap.Premium,
            ViewMap.Update,
            ViewMap.Add,
            ViewMap.PremiumCard,
        ],
    },
    {
        role: UserRole.DeltekPublishingAuthor,
        views: [ViewMap.Premium, ViewMap.Update, ViewMap.PremiumCard],
    },
    {
        role: UserRole.DeltekAuthor,
        views: [ViewMap.Premium, ViewMap.Update, ViewMap.PremiumCard],
    },
    {
        role: UserRole.DeltekReviewer,
        views: [ViewMap.Premium, ViewMap.PremiumCard],
    },
    {
        role: UserRole.Others,
        views: [ViewMap.Premium, ViewMap.PremiumCard],
    },
    {
        role: UserRole.Onboarder,
        views: [
            ViewMap.Premium,
            ViewMap.UpdateLimited,
            ViewMap.AddProductLimited,
            ViewMap.PremiumCard,
        ],
    },
    { role: UserRole.BPMReseller, views: [ViewMap.UpdateSwatchbox] },
]

export const PremiumInactivePremiumMasterSpecReviewBPMSubmitted = [
    {
        role: UserRole.BPMAdmin,
        views: [ViewMap.Premium, ViewMap.Update, ViewMap.PremiumCard],
    },
    {
        role: UserRole.BPMAuthor,
        views: [ViewMap.Premium, ViewMap.Update, ViewMap.PremiumCard],
    },
    {
        role: UserRole.BPMReviewer,
        views: [ViewMap.Premium, ViewMap.PremiumCard],
    },
    {
        role: UserRole.DeltekAdmin,
        views: [
            ViewMap.Premium,
            ViewMap.Update,
            ViewMap.Add,
            ViewMap.PremiumCard,
        ],
    },
    {
        role: UserRole.DeltekPublishingAuthor,
        views: [ViewMap.Premium, ViewMap.Update, ViewMap.PremiumCard],
    },
    {
        role: UserRole.DeltekAuthor,
        views: [ViewMap.Premium, ViewMap.Update, ViewMap.PremiumCard],
    },
    {
        role: UserRole.DeltekReviewer,
        views: [ViewMap.Premium, ViewMap.PremiumCard],
    },
    {
        role: UserRole.Others,
        views: [ViewMap.Premium, ViewMap.PremiumCard],
    },
    {
        role: UserRole.Onboarder,
        views: [
            ViewMap.Premium,
            ViewMap.UpdateLimited,
            ViewMap.AddProductLimited,
            ViewMap.PremiumCard,
        ],
    },
    { role: UserRole.BPMReseller, views: [ViewMap.UpdateSwatchbox] },
]

export const PremiumInactivePremiumProprietaryReview = [
    {
        role: UserRole.BPMAdmin,
        views: [
            ViewMap.Premium,
            ViewMap.Submit,
            ViewMap.Update,
            ViewMap.PremiumCard,
        ],
    },
    {
        role: UserRole.BPMAuthor,
        views: [
            ViewMap.Premium,
            ViewMap.Submit,
            ViewMap.Update,
            ViewMap.PremiumCard,
        ],
    },
    {
        role: UserRole.BPMReviewer,
        views: [ViewMap.Premium, ViewMap.PremiumCard],
    },
    {
        role: UserRole.DeltekAdmin,
        views: [
            ViewMap.Premium,
            ViewMap.Update,
            ViewMap.Add,
            ViewMap.PremiumCard,
        ],
    },
    {
        role: UserRole.DeltekPublishingAuthor,
        views: [ViewMap.Premium, ViewMap.Update, ViewMap.PremiumCard],
    },
    {
        role: UserRole.DeltekAuthor,
        views: [ViewMap.Premium, ViewMap.Update, ViewMap.PremiumCard],
    },
    {
        role: UserRole.DeltekReviewer,
        views: [ViewMap.Premium, ViewMap.PremiumCard],
    },
    {
        role: UserRole.Others,
        views: [ViewMap.Premium, ViewMap.PremiumCard],
    },
    {
        role: UserRole.Onboarder,
        views: [
            ViewMap.Premium,
            ViewMap.UpdateLimited,
            ViewMap.AddProductLimited,
            ViewMap.PremiumCard,
        ],
    },
    { role: UserRole.BPMReseller, views: [ViewMap.UpdateSwatchbox] },
]

export const PremiumInactivePremiumProprietaryReviewBPMSubmitted = [
    {
        role: UserRole.BPMAdmin,
        views: [ViewMap.Premium, ViewMap.Update, ViewMap.PremiumCard],
    },
    {
        role: UserRole.BPMAuthor,
        views: [ViewMap.Premium, ViewMap.Update, ViewMap.PremiumCard],
    },
    {
        role: UserRole.BPMReviewer,
        views: [ViewMap.Premium, ViewMap.PremiumCard],
    },
    {
        role: UserRole.DeltekAdmin,
        views: [
            ViewMap.Premium,
            ViewMap.Update,
            ViewMap.Add,
            ViewMap.PremiumCard,
        ],
    },
    {
        role: UserRole.DeltekPublishingAuthor,
        views: [ViewMap.Premium, ViewMap.Update, ViewMap.PremiumCard],
    },
    {
        role: UserRole.DeltekAuthor,
        views: [ViewMap.Premium, ViewMap.Update, ViewMap.PremiumCard],
    },
    {
        role: UserRole.DeltekReviewer,
        views: [ViewMap.Premium, ViewMap.PremiumCard],
    },
    {
        role: UserRole.Others,
        views: [ViewMap.Premium, ViewMap.PremiumCard],
    },
    {
        role: UserRole.Onboarder,
        views: [
            ViewMap.Premium,
            ViewMap.UpdateLimited,
            ViewMap.AddProductLimited,
            ViewMap.PremiumCard,
        ],
    },
    { role: UserRole.BPMReseller, views: [ViewMap.UpdateSwatchbox] },
]
export const ProductListingActiveCompleted = [
    {
        role: UserRole.BPMAdmin,
        views: [ViewMap.ProductListing, ViewMap.ProductListingCard],
    },
    {
        role: UserRole.BPMAuthor,
        views: [ViewMap.ProductListing, ViewMap.ProductListingCard],
    },
    {
        role: UserRole.BPMReviewer,
        views: [ViewMap.ProductListing, ViewMap.ProductListingCard],
    },
    {
        role: UserRole.DeltekAdmin,
        views: [
            ViewMap.ProductListing,
            ViewMap.Update,
            ViewMap.Add,
            ViewMap.ProductListingCard,
        ],
    },
    {
        role: UserRole.DeltekPublishingAuthor,
        views: [
            ViewMap.ProductListing,
            ViewMap.Update,
            ViewMap.ProductListingCard,
        ],
    },
    {
        role: UserRole.DeltekAuthor,
        views: [
            ViewMap.ProductListing,
            ViewMap.Update,
            ViewMap.ProductListingCard,
        ],
    },
    {
        role: UserRole.DeltekReviewer,
        views: [ViewMap.ProductListing, ViewMap.ProductListingCard],
    },
    {
        role: UserRole.Others,
        views: [ViewMap.ProductListing, ViewMap.ProductListingCard],
    },
    {
        role: UserRole.Onboarder,
        views: [
            ViewMap.ProductListing,
            ViewMap.UpdateLimited,
            ViewMap.AddProductLimited,
            ViewMap.ProductListingCard,
        ],
    },
]
export const ProductListingActiveInReview = [
    {
        role: UserRole.BPMAdmin,
        views: [
            ViewMap.ProductListing,
            ViewMap.Submit,
            ViewMap.Update,
            ViewMap.ProductListingCard,
        ],
    },
    {
        role: UserRole.BPMAuthor,
        views: [
            ViewMap.ProductListing,
            ViewMap.Submit,
            ViewMap.Update,
            ViewMap.ProductListingCard,
        ],
    },
    {
        role: UserRole.BPMReviewer,
        views: [ViewMap.ProductListing, ViewMap.ProductListingCard],
    },
    {
        role: UserRole.DeltekAdmin,
        views: [
            ViewMap.ProductListing,
            ViewMap.Update,
            ViewMap.Add,
            ViewMap.ProductListingCard,
        ],
    },
    {
        role: UserRole.DeltekPublishingAuthor,
        views: [
            ViewMap.ProductListing,
            ViewMap.Update,
            ViewMap.ProductListingCard,
        ],
    },
    {
        role: UserRole.DeltekAuthor,
        views: [
            ViewMap.ProductListing,
            ViewMap.Update,
            ViewMap.ProductListingCard,
        ],
    },
    {
        role: UserRole.DeltekReviewer,
        views: [ViewMap.ProductListing, ViewMap.ProductListingCard],
    },
    {
        role: UserRole.Others,
        views: [ViewMap.ProductListing, ViewMap.ProductListingCard],
    },
    {
        role: UserRole.Onboarder,
        views: [
            ViewMap.ProductListing,
            ViewMap.UpdateLimited,
            ViewMap.AddProductLimited,
            ViewMap.ProductListingCard,
        ],
    },
    { role: UserRole.BPMReseller, views: [ViewMap.UpdateSwatchbox] },
]
export const ProductListingActiveBPMSubmitted = [
    {
        role: UserRole.BPMAdmin,
        views: [
            ViewMap.ProductListing,
            ViewMap.Update,
            ViewMap.ProductListingCard,
        ],
    },
    {
        role: UserRole.BPMAuthor,
        views: [
            ViewMap.ProductListing,
            ViewMap.Update,
            ViewMap.ProductListingCard,
        ],
    },
    {
        role: UserRole.BPMReviewer,
        views: [ViewMap.ProductListing, ViewMap.ProductListingCard],
    },
    {
        role: UserRole.DeltekAdmin,
        views: [
            ViewMap.ProductListing,
            ViewMap.Update,
            ViewMap.Add,
            ViewMap.ProductListingCard,
        ],
    },
    {
        role: UserRole.DeltekPublishingAuthor,
        views: [
            ViewMap.ProductListing,
            ViewMap.Update,
            ViewMap.ProductListingCard,
        ],
    },
    {
        role: UserRole.DeltekAuthor,
        views: [
            ViewMap.ProductListing,
            ViewMap.Update,
            ViewMap.ProductListingCard,
        ],
    },
    {
        role: UserRole.DeltekReviewer,
        views: [ViewMap.ProductListing, ViewMap.ProductListingCard],
    },
    {
        role: UserRole.Others,
        views: [ViewMap.ProductListing, ViewMap.ProductListingCard],
    },
    {
        role: UserRole.Onboarder,
        views: [
            ViewMap.ProductListing,
            ViewMap.UpdateLimited,
            ViewMap.AddProductLimited,
            ViewMap.ProductListingCard,
        ],
    },
    { role: UserRole.BPMReseller, views: [ViewMap.UpdateSwatchbox] },
]
export const ProductListingInactiveCompleted = [
    {
        role: UserRole.BPMAdmin,
        views: [ViewMap.ProductListing, ViewMap.ProductListingCard],
    },
    {
        role: UserRole.BPMAuthor,
        views: [ViewMap.ProductListing, ViewMap.ProductListingCard],
    },
    {
        role: UserRole.BPMReviewer,
        views: [ViewMap.ProductListing, ViewMap.ProductListingCard],
    },
    {
        role: UserRole.DeltekAdmin,
        views: [
            ViewMap.ProductListing,
            ViewMap.Update,
            ViewMap.Add,
            ViewMap.ProductListingCard,
        ],
    },
    {
        role: UserRole.DeltekPublishingAuthor,
        views: [
            ViewMap.ProductListing,
            ViewMap.Update,
            ViewMap.ProductListingCard,
        ],
    },
    {
        role: UserRole.DeltekAuthor,
        views: [
            ViewMap.ProductListing,
            ViewMap.Update,
            ViewMap.ProductListingCard,
        ],
    },
    {
        role: UserRole.DeltekReviewer,
        views: [ViewMap.ProductListing, ViewMap.ProductListingCard],
    },
    {
        role: UserRole.Others,
        views: [ViewMap.ProductListing, ViewMap.ProductListingCard],
    },
    {
        role: UserRole.Onboarder,
        views: [
            ViewMap.ProductListing,
            ViewMap.UpdateLimited,
            ViewMap.AddProductLimited,
            ViewMap.ProductListingCard,
        ],
    },
]
export const ProductListingInactiveInReview = [
    {
        role: UserRole.BPMAdmin,
        views: [
            ViewMap.ProductListing,
            ViewMap.Submit,
            ViewMap.Update,
            ViewMap.ProductListingCard,
        ],
    },
    {
        role: UserRole.BPMAuthor,
        views: [
            ViewMap.ProductListing,
            ViewMap.Submit,
            ViewMap.Update,
            ViewMap.ProductListingCard,
        ],
    },
    {
        role: UserRole.BPMReviewer,
        views: [ViewMap.ProductListing, ViewMap.ProductListingCard],
    },
    {
        role: UserRole.DeltekAdmin,
        views: [
            ViewMap.ProductListing,
            ViewMap.Update,
            ViewMap.Add,
            ViewMap.ProductListingCard,
        ],
    },
    {
        role: UserRole.DeltekPublishingAuthor,
        views: [
            ViewMap.ProductListing,
            ViewMap.Update,
            ViewMap.ProductListingCard,
        ],
    },
    {
        role: UserRole.DeltekAuthor,
        views: [
            ViewMap.ProductListing,
            ViewMap.Update,
            ViewMap.ProductListingCard,
        ],
    },
    {
        role: UserRole.DeltekReviewer,
        views: [ViewMap.ProductListing, ViewMap.ProductListingCard],
    },
    {
        role: UserRole.Others,
        views: [ViewMap.ProductListing, ViewMap.ProductListingCard],
    },
    {
        role: UserRole.Onboarder,
        views: [
            ViewMap.ProductListing,
            ViewMap.UpdateLimited,
            ViewMap.AddProductLimited,
            ViewMap.ProductListingCard,
        ],
    },
    { role: UserRole.BPMReseller, views: [ViewMap.UpdateSwatchbox] },
]

export const ProductListingInactiveBPMSubmitted = [
    {
        role: UserRole.BPMAdmin,
        views: [
            ViewMap.ProductListing,
            ViewMap.Update,
            ViewMap.ProductListingCard,
        ],
    },
    {
        role: UserRole.BPMAuthor,
        views: [
            ViewMap.ProductListing,
            ViewMap.Update,
            ViewMap.ProductListingCard,
        ],
    },
    {
        role: UserRole.BPMReviewer,
        views: [ViewMap.ProductListing, ViewMap.ProductListingCard],
    },
    {
        role: UserRole.DeltekAdmin,
        views: [
            ViewMap.ProductListing,
            ViewMap.Update,
            ViewMap.Add,
            ViewMap.ProductListingCard,
        ],
    },
    {
        role: UserRole.DeltekPublishingAuthor,
        views: [
            ViewMap.ProductListing,
            ViewMap.Update,
            ViewMap.ProductListingCard,
        ],
    },
    {
        role: UserRole.DeltekAuthor,
        views: [
            ViewMap.ProductListing,
            ViewMap.Update,
            ViewMap.ProductListingCard,
        ],
    },
    {
        role: UserRole.DeltekReviewer,
        views: [ViewMap.ProductListing, ViewMap.ProductListingCard],
    },
    {
        role: UserRole.Others,
        views: [ViewMap.ProductListing, ViewMap.ProductListingCard],
    },
    {
        role: UserRole.Onboarder,
        views: [
            ViewMap.ProductListing,
            ViewMap.UpdateLimited,
            ViewMap.AddProductLimited,
            ViewMap.ProductListingCard,
        ],
    },
    { role: UserRole.BPMReseller, views: [ViewMap.UpdateSwatchbox] },
]

export const listingDetailsRoleMapping: ListingRoles[] = [
    {
        listingType: ListingLevel.Manufacturer,
        isactive: true,
        status: ListingStatus.Completed,
        tags: MFGActiveCompleted,
    },
    {
        listingType: ListingLevel.Manufacturer,
        isactive: true,
        status: ListingStatus.PremiumReview,
        tags: MFGActivePremiumReview,
    },
    {
        listingType: ListingLevel.Manufacturer,
        isactive: true,
        status: ListingStatus.PremiumReviewBPMSubmitted,
        tags: MFGActivePremiumReviewBPMSubmitted,
    },
    {
        listingType: ListingLevel.Manufacturer,
        isactive: true,
        status: ListingStatus.PremiumMasterSpecReview,
        tags: MFGActivePremiumMasterSpecReview,
    },
    {
        listingType: ListingLevel.Manufacturer,
        isactive: true,
        status: ListingStatus.PremiumMasterSpecReviewBPMSubmitted,
        tags: MFGActivePremiumMasterSpecReviewBPMSubmitted,
    },
    {
        listingType: ListingLevel.Manufacturer,
        isactive: true,
        status: ListingStatus.ProprietaryReview,
        tags: MFGActivePremiumProprietaryReview,
    },
    {
        listingType: ListingLevel.Manufacturer,
        isactive: true,
        status: ListingStatus.ProprietaryReviewBPMSubmitted,
        tags: MFGActivePremiumProprietaryReviewBPMSubmitted,
    },
    {
        listingType: ListingLevel.Manufacturer,
        isactive: true,
        status: ListingStatus.InReview,
        tags: MFGActiveInReview,
    },
    {
        listingType: ListingLevel.Manufacturer,
        isactive: true,
        status: ListingStatus.BPMSubmitted,
        tags: MFGActiveBPMSubmitted,
    },
    {
        listingType: ListingLevel.Manufacturer,
        isactive: true,
        status: ListingStatus.Deprecated,
        tags: MFGActivePremiumProprietaryReview,
    },
    {
        listingType: ListingLevel.Manufacturer,
        isactive: false,
        status: ListingStatus.Completed,
        tags: MFGInactiveCompleted,
    },
    {
        listingType: ListingLevel.Manufacturer,
        isactive: false,
        status: ListingStatus.PremiumReview,
        tags: MFGInactivePremiumReview,
    },
    {
        listingType: ListingLevel.Manufacturer,
        isactive: false,
        status: ListingStatus.PremiumReviewBPMSubmitted,
        tags: MFGInactivePremiumReviewBPMSubmitted,
    },
    {
        listingType: ListingLevel.Manufacturer,
        isactive: false,
        status: ListingStatus.PremiumMasterSpecReview,
        tags: MFGInactivePremiumMasterSpecReview,
    },
    {
        listingType: ListingLevel.Manufacturer,
        isactive: false,
        status: ListingStatus.PremiumMasterSpecReviewBPMSubmitted,
        tags: MFGInactivePremiumMasterSpecReviewBPMSubmitted,
    },
    {
        listingType: ListingLevel.Manufacturer,
        isactive: false,
        status: ListingStatus.ProprietaryReview,
        tags: MFGInactivePremiumProprietaryReview,
    },
    {
        listingType: ListingLevel.Manufacturer,
        isactive: false,
        status: ListingStatus.ProprietaryReviewBPMSubmitted,
        tags: MFGInactivePremiumProprietaryReviewBPMSubmitted,
    },
    {
        listingType: ListingLevel.Manufacturer,
        isactive: false,
        status: ListingStatus.InReview,
        tags: MFGInactiveInReview,
    },
    {
        listingType: ListingLevel.Manufacturer,
        isactive: false,
        status: ListingStatus.BPMSubmitted,
        tags: MFGInactiveBPMSubmitted,
    },
    {
        listingType: ListingLevel.Premium,
        isactive: true,
        status: ListingStatus.Completed,
        tags: PremiumActiveComplete,
    },
    {
        listingType: ListingLevel.Premium,
        isactive: true,
        status: ListingStatus.PremiumReview,
        tags: PremiumActivePremiumReview,
    },
    {
        listingType: ListingLevel.Premium,
        isactive: true,
        status: ListingStatus.PremiumReviewBPMSubmitted,
        tags: PremiumActivePremiumReviewBPMSubmitted,
    },
    {
        listingType: ListingLevel.Premium,
        isactive: true,
        status: ListingStatus.PremiumMasterSpecReview,
        tags: PremiumActivePremiumMasterSpecReview,
    },
    {
        listingType: ListingLevel.Premium,
        isactive: true,
        status: ListingStatus.PremiumMasterSpecReviewBPMSubmitted,
        tags: PremiumActivePremiumMasterSpecReviewBPMSubmitted,
    },
    {
        listingType: ListingLevel.Premium,
        isactive: true,
        status: ListingStatus.ProprietaryReview,
        tags: PremiumActivePremiumProprietaryReview,
    },
    {
        listingType: ListingLevel.Premium,
        isactive: true,
        status: ListingStatus.ProprietaryReviewBPMSubmitted,
        tags: PremiumActivePremiumProprietaryReviewBPMSubmitted,
    },
    {
        listingType: ListingLevel.Premium,
        isactive: false,
        status: ListingStatus.Completed,
        tags: PremiumInactiveComplete,
    },
    {
        listingType: ListingLevel.Premium,
        isactive: false,
        status: ListingStatus.PremiumReview,
        tags: PremiumInactivePremiumReview,
    },
    {
        listingType: ListingLevel.Premium,
        isactive: false,
        status: ListingStatus.PremiumReviewBPMSubmitted,
        tags: PremiumInactivePremiumReviewBPMSubmitted,
    },
    {
        listingType: ListingLevel.Premium,
        isactive: false,
        status: ListingStatus.PremiumMasterSpecReview,
        tags: PremiumInactivePremiumMasterSpecReview,
    },
    {
        listingType: ListingLevel.Premium,
        isactive: false,
        status: ListingStatus.PremiumMasterSpecReviewBPMSubmitted,
        tags: PremiumInactivePremiumMasterSpecReviewBPMSubmitted,
    },
    {
        listingType: ListingLevel.Premium,
        isactive: false,
        status: ListingStatus.ProprietaryReview,
        tags: PremiumInactivePremiumProprietaryReview,
    },
    {
        listingType: ListingLevel.Premium,
        isactive: false,
        status: ListingStatus.ProprietaryReviewBPMSubmitted,
        tags: PremiumInactivePremiumProprietaryReviewBPMSubmitted,
    },
    // Product Listing with new status
    {
        listingType: ListingLevel.ProductListing,
        isactive: true,
        status: ListingStatus.Completed,
        tags: ProductListingActiveCompleted,
    },
    {
        listingType: ListingLevel.ProductListing,
        isactive: true,
        status: ListingStatus.InReview,
        tags: ProductListingActiveInReview,
    },
    {
        listingType: ListingLevel.ProductListing,
        isactive: true,
        status: ListingStatus.BPMSubmitted,
        tags: ProductListingActiveBPMSubmitted,
    },
    {
        listingType: ListingLevel.ProductListing,
        isactive: false,
        status: ListingStatus.Completed,
        tags: ProductListingInactiveCompleted,
    },
    {
        listingType: ListingLevel.ProductListing,
        isactive: false,
        status: ListingStatus.InReview,
        tags: ProductListingInactiveInReview,
    },
    {
        listingType: ListingLevel.ProductListing,
        isactive: false,
        status: ListingStatus.BPMSubmitted,
        tags: ProductListingInactiveBPMSubmitted,
    },

    // Product Listing with old status
    {
        listingType: ListingLevel.ProductListing,
        isactive: true,
        status: ListingStatus.Completed,
        tags: PremiumActiveComplete,
    },
    {
        listingType: ListingLevel.ProductListing,
        isactive: true,
        status: ListingStatus.PremiumReview,
        tags: PremiumActivePremiumReview,
    },
    {
        listingType: ListingLevel.ProductListing,
        isactive: true,
        status: ListingStatus.PremiumReviewBPMSubmitted,
        tags: PremiumActivePremiumReviewBPMSubmitted,
    },
    {
        listingType: ListingLevel.ProductListing,
        isactive: true,
        status: ListingStatus.PremiumMasterSpecReview,
        tags: PremiumActivePremiumMasterSpecReview,
    },
    {
        listingType: ListingLevel.ProductListing,
        isactive: true,
        status: ListingStatus.PremiumMasterSpecReviewBPMSubmitted,
        tags: PremiumActivePremiumMasterSpecReviewBPMSubmitted,
    },
    {
        listingType: ListingLevel.ProductListing,
        isactive: true,
        status: ListingStatus.ProprietaryReview,
        tags: PremiumActivePremiumProprietaryReview,
    },
    {
        listingType: ListingLevel.ProductListing,
        isactive: true,
        status: ListingStatus.ProprietaryReviewBPMSubmitted,
        tags: PremiumActivePremiumProprietaryReviewBPMSubmitted,
    },
    {
        listingType: ListingLevel.ProductListing,
        isactive: false,
        status: ListingStatus.Completed,
        tags: PremiumInactiveComplete,
    },
    {
        listingType: ListingLevel.ProductListing,
        isactive: false,
        status: ListingStatus.PremiumReview,
        tags: PremiumInactivePremiumReview,
    },
    {
        listingType: ListingLevel.ProductListing,
        isactive: false,
        status: ListingStatus.PremiumReviewBPMSubmitted,
        tags: PremiumInactivePremiumReviewBPMSubmitted,
    },
    {
        listingType: ListingLevel.ProductListing,
        isactive: false,
        status: ListingStatus.PremiumMasterSpecReview,
        tags: PremiumInactivePremiumMasterSpecReview,
    },
    {
        listingType: ListingLevel.ProductListing,
        isactive: false,
        status: ListingStatus.PremiumMasterSpecReviewBPMSubmitted,
        tags: PremiumInactivePremiumMasterSpecReviewBPMSubmitted,
    },
    {
        listingType: ListingLevel.ProductListing,
        isactive: false,
        status: ListingStatus.ProprietaryReview,
        tags: PremiumInactivePremiumProprietaryReview,
    },
    {
        listingType: ListingLevel.ProductListing,
        isactive: false,
        status: ListingStatus.ProprietaryReviewBPMSubmitted,
        tags: PremiumInactivePremiumProprietaryReviewBPMSubmitted,
    },
]
export const getRoleBasedAccess = ({
    userRole,
    isactive,
    listingType,
    status,
}: UserAndProductInfo): RoleBasedAcessMatrix => {
    let mFGOnly = false,
        mFG = false,
        premium = false,
        productListing = false,
        submit = false,
        update = false,
        add = false,
        mFGCardOnly = false,
        premiumCard = false,
        productListingCard = false,
        updateSwatchbox = false
    const getTargetTags = getTags({ isactive, status, listingType })
    const associatedViewsObj = getTargetTags.filter((t) => t.role === userRole)

    if (associatedViewsObj.length !== 0) {
        const associatedViews = associatedViewsObj[0]?.views
        mFGOnly = associatedViews.includes(ViewMap.MFGOnly)
        mFG = associatedViews.includes(ViewMap.MFG)
        premium = associatedViews.includes(ViewMap.Premium)
        productListing = associatedViews.includes(ViewMap.ProductListing)
        submit = associatedViews.includes(ViewMap.Submit)
        update = associatedViews.includes(ViewMap.Update)
        add = associatedViews.includes(ViewMap.Add)
        mFGCardOnly = associatedViews.includes(ViewMap.MFGCardOnly)
        premiumCard = associatedViews.includes(ViewMap.PremiumCard)
        productListingCard = associatedViews.includes(
            ViewMap.ProductListingCard
        )
        updateSwatchbox =
            associatedViews.includes(ViewMap.UpdateSwatchbox) &&
            !!Number(processEnv.REACT_APP_ShowSwatchbox)
    }

    return {
        mFGOnly,
        mFG,
        premium,
        productListing,
        submit,
        update,
        add,
        mFGCardOnly,
        premiumCard,
        productListingCard,
        updateSwatchbox,
    }
}

export const getTags = ({
    isactive,
    listingType,
    status,
}: Partial<ListingRoles>) => {
    const targetRole = listingDetailsRoleMapping.filter(
        (ldr) =>
            ldr.isactive === isactive &&
            listingType?.includes(ldr.listingType) &&
            ldr.status === status
    )
    return (targetRole.length !== 0 && targetRole[0].tags) || []
}
